import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import MemberSidebar from "../inc/MemberSidebar";

export default function ProposalResultReport(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;

    let member = prop.member;
    let [listing, setListing] = React.useState(null);
    let [detail, setDetail] = React.useState(null);
    let [statusList, setStatusList] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resultStatus = await Utils.getResultStatus();
                setStatusList(resultStatus);

                const result = await getListing();
                setListing(result);

                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if (prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }
                }

                document.title = 'ข้อเสนอโครงการ | NCSA -' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListing() {
        const response = await fetch(Config.apiUrl +'/proposalResult/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="result" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 mb-3">{prop.lang === 'en' ? 'Report Results':'รายงานผลลัพธ์'}</h2>
                                <h4 className="title-line-left mb-3">{(prop.lang === 'en' ? 'Project : ':'โครงการ : ') + detail?.title}</h4>
                                <div className="d-flex justify-content-between gap-3">
                                    <h6 className="pt-1">{(prop.lang === 'en' ? 'Reported ' + listing?.count + '  ':'รายงานแล้ว ' + listing?.count + ' time(s)')}</h6>
                                    <NavLink className="btn btn-xs btn-green" to={(prop.lang === 'en' ? '/en/':'') + '/proposalResult/report/create/' + Utils.encodeItem({proposalId: detail?.id})}>{prop.lang === 'en' ? '+ Add New Report':'+ เพิ่มรายงานผลลัพธ์'}</NavLink>
                                </div>
                                <div className="table-responsive mt-3">
                                    <table className="table table-info table-hover text-center">
                                        <thead>
                                            <tr key={-2}>
                                                <th className="text-center" style={{width: '110px'}}>{prop.lang === 'en' ? 'Subject':'หัวข้อ'}</th>
                                                <th style={{width: '150px'}} className="text-center">{prop.lang === 'en' ? 'Progress percentage':'ร้อยละความก้าวหน้า'}</th>
                                                <th className="text-start">{prop.lang === 'en' ? 'Summary of operating results':'สรุปผลการดำเนินงาน'}</th>
                                                <th className="text-center" style={{width: '130px'}}>{prop.lang === 'en' ? 'Send date':'วันที่ส่งรายงาน'}</th>
                                                <th style={{width: '70px'}}>{prop.lang === 'en' ? 'Status':'สถานะ'}</th>
                                                <th style={{width: '130px'}}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            listing !== null && listing.count > 0 ?
                                                listing.rows.map((row, index) => {
                                                    return (<>
                                                        <tr key={index}>
                                                            <td className="text-center">{(prop.lang === 'en' ? 'Period ':'งวดงานที่ ') + row.periodNo}</td>
                                                            <td className="text-center">{row.percent}%</td>
                                                            <td className="text-start">{row.summary.substr(0, 50) + (row.summary.length > 50 ? '...':'')}</td>
                                                            <td className="text-center">{Utils.dateTime(row.sendDate)}</td>
                                                            <td><span className={"badge " + (Utils.resultStatusColor(row.status))}>{statusList.filter(e => e.id === row.status)[0].title}</span></td>
                                                            <td>
                                                                <NavLink className="btn btn-xs btn-primary" to={(prop.lang === 'en' ? '/en/':'') + '/proposalResult/report/manage/' + Utils.encodeItem({id: row.id})}>{prop.lang === 'en' ? (row.status === Utils.REPORT_RESULT_EDIT ? 'Edit':'View'):(row.status === Utils.REPORT_RESULT_EDIT ? 'แก้ไข':'รายละเอียด')}</NavLink>
                                                            </td>
                                                        </tr>
                                                        </>
                                                    )
                                                }) : <tr key={-1}><td colSpan={5} className="text-center">{prop.lang === 'en' ? 'No found report':'ยังไม่มีรายงาน'}</td></tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="buttons gap-15 py-0 mt-4">
                                <NavLink className="btn btn-gray w-130" to={(prop.lang === 'en' ? '/en':'') + '/proposalResult'
                                }>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</NavLink>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 